import {
  GET_PARAMETROS_GLOBAIS_INIT,
  GET_PARAMETROS_GLOBAIS_SUCCESS,
  UPDATE_PARAMETROS_GLOBAIS_INIT,
  UPDATE_PARAMETROS_GLOBAIS_SUCCESS,
  PARAMETROS_GLOBAIS_ERROR_MSG,
  CLEAR_PARAMETROS_GLOBAIS
} from '../actionTypes';

export const getParametrosGlobaisInit = (data) => ({
  type: GET_PARAMETROS_GLOBAIS_INIT,
  payload: data
});

export const getParametrosGlobaisSuccess = (data) => {
  return {
    type: GET_PARAMETROS_GLOBAIS_SUCCESS,
    payload: data
  };
};

export const updateParametrosGlobaisInit = (data) => ({
  type: UPDATE_PARAMETROS_GLOBAIS_INIT,
  payload: data
});

export const updateParametrosGlobaisSuccess = (data) => ({
  type: UPDATE_PARAMETROS_GLOBAIS_SUCCESS,
  payload: data
});

export const parametrosGlobaisErrorMsg = (data) => ({
  type: PARAMETROS_GLOBAIS_ERROR_MSG,
  payload: data
});

export const clearParametrosGlobais = (data) => ({
  type: CLEAR_PARAMETROS_GLOBAIS,
  payload: data
});

